import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { addUser, AuthenticateUser } from "../../services/AuthenticationService";
import { useDispatch } from "react-redux";
import { login } from "../../redux/slices/authSlice";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useForm } from "react-hook-form";
import User from "../../utils/json/User";
import WhatsAppButton from "../WhatsappInt";
import './Login.css';
const LoginPage = () => {


  useEffect(() => {
    sessionStorage.setItem("signin", "false");
  }, [])

const {
  register,
  handleSubmit,
}=useForm({mode:"onChange",reValidateMode:"onChange"});


  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [showPassword, setShowPassword] = useState(false);


  const handleSetFlag = () => {
    sessionStorage.setItem("signin", "true");
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const handleLogin = async (userData) => {
    console.log("object1",userData)
    const objUser = new User();
objUser.UserName= userData.UserName;
objUser.Password=userData.Password;
    
    try {
      const response = await AuthenticateUser(objUser);
      console.log('AuthenticateUser response:', response);
    
      if (response) {
        toast.success("Login Success");
        //store data to redux 
         const userId = response;
         console.log(userId)
         dispatch(login({ userId: response }));
         handleSetFlag();
        navigate("/"); 
      } else {
        toast.error("Login failed!");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again!");
    }
  };
  return (
    <>
    {/* <div className="container-xxl pt-5">
      <div className="container py-3"> */}
        <div className="login-wrapper">
          <div className="login-image" data-wow-delay="0.1s">
            <img className="img-fluid m-0" src="/images/menu-1.jpg" alt="" />
          </div>
   
          <div className="login-form-box" data-wow-delay="0.5s">
          <form action="/" className="contact-form" onSubmit={handleSubmit(handleLogin)}>
              <div className="row">
              <div className="heading-section" data-aos="fade-up">
              <p className="subheading  text-center">Login</p>
            </div>
                <div className="mt-5">
                  <div className="form-group position-relative">
                    <input 
                    type="text"
                     name="userName"
                     className="form-control"
                     placeholder="UserName"
                     {...register("UserName",{required:true})}
                     
                     />
                  </div>
                </div>
              </div>
              <div className="">
              <div className="form-group position-relative">
                <input 
                type={showPassword? "text" :"password"}
                className="form-control" 
                placeholder="Password" 
                name="password"
                {...register("Password",{required:true})}
                 />
                <span
                    className="password-toggle-icon"
                    onClick={togglePasswordVisibility}
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#fff",
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
              </div>
           </div>
              <div className="form-group position-relative">
                <input type="submit" value="LOGIN" className="btn btn-primary" />
              </div>
              <div className="text-center mt-3">
                <p><span className="primary-color">
                  <Link className="nav-link" to="/register">Create an account</Link></span></p>
              </div>
            </form>
      
           
           
          </div>
        </div>
      {/* </div>
  
    </div> */}
    </>
  );
};

export default LoginPage;
